/*
==================================
KP HEADER
==================================
*/

const KPHeader = {

    header: null,

    lastScroll: 0,

    init() {

        this.header = document.querySelector(".kp-header");

        if (!this.header) return;

        window.addEventListener(

            "scroll",

            () => this.handleScroll()

        );

    },

    handleScroll() {

        const currentScroll = window.pageYOffset;

        if (currentScroll > 20) {

            this.header.classList.add("is-scrolled");

        } else {

            this.header.classList.remove("is-scrolled");

        }
                if (!this.header.classList.contains("hide-scroll")) {

            this.lastScroll = currentScroll;

            return;

        }

        if (

            currentScroll > this.lastScroll &&

            currentScroll > 120

        ) {

            this.header.classList.add("is-hidden");

        }

        else {

            this.header.classList.remove("is-hidden");

        }

        this.lastScroll = currentScroll;

    }

};

document.addEventListener(

    "DOMContentLoaded",

    function () {

        KPHeader.init();

    }

);